import controller from './proceedings-list.controller';
import template from './proceedings-list.view.html';

let ProceedingsListComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ProceedingsListComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/proceedings-list/proceedings-list.component.js
 **/